"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findChildren = exports.buildGraph = void 0;
const dep_graph_1 = require("@snyk/dep-graph");
async function buildGraph(snykGraph, projectName, projectVersion, coordinateMap) {
    const pkgManager = { name: 'gradle' };
    const isEmptyGraph = !snykGraph || Object.keys(snykGraph).length === 0;
    const depGraphBuilder = new dep_graph_1.DepGraphBuilder(pkgManager, {
        name: projectName,
        version: projectVersion || '0.0.0',
    });
    if (isEmptyGraph) {
        return depGraphBuilder.build();
    }
    const visited = [];
    const queue = [];
    queue.push(...findChildren('root-node', snykGraph)); // queue direct dependencies
    // breadth first search
    while (queue.length > 0) {
        const item = queue.shift();
        if (!item)
            continue;
        let { id, parentId } = item;
        // take a copy as id maybe mutated below and we need this id when finding childing in snykGraph
        const snykGraphId = `${id}`;
        const node = snykGraph[id];
        if (!node)
            continue;
        let { name = 'unknown', version = 'unknown' } = node;
        if (coordinateMap) {
            if (coordinateMap[id]) {
                id = coordinateMap[id];
                const [newName, newVersion] = id.split('@');
                name = newName;
                version = newVersion;
            }
            if (coordinateMap[parentId]) {
                parentId = coordinateMap[parentId];
            }
        }
        if (visited.includes(id)) {
            const prunedId = id + ':pruned';
            depGraphBuilder.addPkgNode({ name, version }, prunedId, {
                labels: { pruned: 'true' },
            });
            depGraphBuilder.connectDep(parentId, prunedId);
            continue; // don't queue any more children
        }
        depGraphBuilder.addPkgNode({ name, version }, id);
        depGraphBuilder.connectDep(parentId, id);
        queue.push(...findChildren(snykGraphId, snykGraph)); // queue children
        visited.push(id);
    }
    return depGraphBuilder.build();
}
exports.buildGraph = buildGraph;
function findChildren(parentId, snykGraph) {
    var _a;
    const result = [];
    for (const id of Object.keys(snykGraph)) {
        const node = snykGraph[id];
        if ((_a = node === null || node === void 0 ? void 0 : node.parentIds) === null || _a === void 0 ? void 0 : _a.includes(parentId)) {
            result.push({ id, parentId });
        }
    }
    return result;
}
exports.findChildren = findChildren;
//# sourceMappingURL=graph.js.map